import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  asbestosInspections: "AsbestosInspection.AsbestosInspections",
  list: "AsbestosInspection.AsbestosInspectionList",
  new: "AsbestosInspection.AsbestosInspectionNew",
  base: "AsbestosInspection.AsbestosInspectionBase",
  view: "AsbestosInspection.AsbestosInspectionView",
  edit: "AsbestosInspection.AsbestosInspectionEdit",
  complete: "AsbestosInspection.AsbestosInspectionComplete",
  recomplete: "AsbestosInspection.AsbestosInspectionRecomplete",
  approve: "AsbestosInspection.AsbestosInspectionApprove",
  reject: "AsbestosInspection.AsbestosInspectionReject",
  documents: "AsbestosInspection.AsbestosInspectionDocuments",
  documentsEdit: "AsbestosInspection.AsbestosInspectionDocumentsEdit",
  documentsNew: "AsbestosInspection.AsbestosInspectionDocumentsNew",
  inspectionNotes: "AsbestosInspection.AsbestosInspectionNotes",
  noteEdit: "AsbestosInspection.AsbestosInspectionNoteEdit",
  noteNew: "AsbestosInspection.AsbestosInspectionNoteNew",
  audit: "AsbestosInspection.AsbestosInspectionAudit",
};

export { names as asbestosInspectionRouteNames };

const asbestosInspectionRoutes: RouterOptions["routes"] = [
  {
    path: "/asbestosInspection",
    name: names.asbestosInspections,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Asbestos Inspections",
          lookupGroups: ["ProgramType", "InspectionStatus", "InspectionType"],
        },
        component: () => import("@/views/asbestosInspections/AsbestosInspectionList.vue"),
      },
      {
        path: "new/:asbestosProjectId(\\d+)?",
        component: () => import("@/views/asbestosInspections/AsbestosInspectionBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Asbestos Inspection", isNew: true },
            component: () => import("@/views/asbestosInspections/AsbestosInspectionEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/asbestosInspections/AsbestosInspectionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Asbestos Inspection View" },
            component: () => import("@/views/asbestosInspections/AsbestosInspectionView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Asbestos Inspection Edit", isForm: true },
            component: () => import("@/views/asbestosInspections/AsbestosInspectionEdit.vue"),
          },
          {
            path: "complete",
            name: names.complete,
            meta: { title: "Complete Inspection", isForm: true },
            component: () => import("@/views/asbestosInspections/CompleteInspection.vue"),
          },
          {
            path: "recomplete",
            name: names.recomplete,
            meta: { title: "Recomplete Inspection", isForm: true },
            component: () => import("@/views/asbestosInspections/RecompleteInspection.vue"),
          },
          {
            path: "approve",
            name: names.approve,
            meta: { title: "Approve Inspection", isForm: true },
            component: () => import("@/views/asbestosInspections/ApproveInspection.vue"),
          },
          {
            path: "reject",
            name: names.reject,
            meta: { title: "Reject Inspection", isForm: true },
            component: () => import("@/views/asbestosInspections/RejectInspection.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Asbestos Inspection Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="asbestosInspection" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Asbestos Inspection Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="asbestosInspection" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Asbestos Inspection Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="asbestosInspection" />,
            },
          },
          {
            path: "notes",
            name: names.inspectionNotes,
            meta: { title: "Asbestos Inspection Notes" },
            component: {
              render: () => (
                <EntityNotes idField="inspectionId" routeNamePrefix="AsbestosInspection.AsbestosInspectionNote" />
              ),
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Asbestos Inspection Note", isForm: true },
            component: () => import("@/views/asbestosInspections/AsbestosInspectionNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Asbestos Inspection Note", isForm: true },
            component: () => import("@/views/asbestosInspections/AsbestosInspectionNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Asbestos Inspection Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="inspection" />,
            },
          },
        ],
      },
    ],
  },
];
export default asbestosInspectionRoutes;
